import Vue from 'vue';
import PersonFields from './_components/PersonFields';

(function() {
    new Vue({
        el: '#person-fields',

        components: {
            PersonFields,
        },
        template: '<PersonFields :person="person" :userIsAdmin="userIsAdmin" :newPerson="newPerson" :phone-number-types="phoneNumberTypes" />',

        data: {
            userIsAdmin,
            person,
            newPerson,
            phoneNumberTypes,
        },
    });
})();
